import { render, staticRenderFns } from "./SportResultForm.vue?vue&type=template&id=c5aebd1e&"
import script from "./SportResultForm.vue?vue&type=script&lang=js&"
export * from "./SportResultForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports